import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  auth = inject(AuthService);
  router = inject(Router);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    if (this.auth.isAuthenticated()) return true;
    const targetUrl = state.url || '/';
    sessionStorage.setItem('post_login_redirect', targetUrl);
    return this.router.createUrlTree(['/login'], {
      queryParams: { returnUrl: targetUrl },
    });
  }
}
